<template>
    <div class="playground-layout">
        <div class="gh-container" :class="containerClass">
            <gh-breadcrumb
                v-if="showBreadcrumb"
                :node-list="nodeList"
            ></gh-breadcrumb>

            <div v-if="showTitle" class="gh-playground-layout__title-container">
                <div class="gh-playground-layout__title-content">
                    <div>
                        <h1
                            class="gh-playground-layout__title-main gh-font-size-30"
                        >
                            {{ title }}
                        </h1>
                        <br />
                        <span
                            class="gh-playground-layout__title-sub gh-font-size-20"
                        >
                            {{ subtitle }}
                        </span>
                        <br />
                        <slot name="title-extra"></slot>
                    </div>
                </div>
            </div>

            <div class="gh-playground-layout__content-outer">
                <div class="gh-playground-layout__content-inner">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import GhBreadcrumb from '@/components/base/GhBreadcrumb.vue';
    import type { BreadcrumbNodeItem } from '@/types/components/base-components.types';

    // ----- props -----
    withDefaults(
        defineProps<{
            nodeList?: BreadcrumbNodeItem[];
            title?: string;
            subtitle?: string;
            containerClass?: string;
            showBreadcrumb?: boolean;
            showTitle?: boolean;
        }>(),
        {
            nodeList: () => [],
            title: '',
            subtitle: '',
            containerClass: 'playground-page',
            showBreadcrumb: true,
            showTitle: true,
        }
    );
</script>

<style lang="scss" scoped>
    @use 'sass:color';

    .playground-page {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .gh-playground-layout__title-container,
    .gh-playground-layout__content-outer {
        width: $contentOuter;
        margin: 0 auto;
        transition: width 0.3s ease-out;

        @include rwdL($fullHD) {
            width: $contentOuterHD;
        }

        @include rwd($fullHD - 1) {
            width: 1000px;
        }

        @include rwd($contentOuterHD) {
            width: 80%;
        }

        @include rwd($pc + 10) {
            width: 90%;
        }

        @include rwd($pad) {
            width: 100%;
        }
    }

    .gh-playground-layout__content-inner {
        position: relative;
        width: 100%;
        float: left;
    }

    .gh-playground-layout__title-content {
        position: relative;
        text-align: center;

        // 置中於標題文字後方的水平分隔線，由文字底色遮蓋中段
        &::before {
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            left: 0;
            border-top: 1px solid $grayColorB0;
        }

        > div {
            position: relative;
            display: inline-block;
            padding: 0 40px;
            background-color: $bg-gray-light-FD;
        }
    }

    .gh-playground-layout__title-main {
        display: inline;
        margin: 0;
        color: $mainColor_blue_124CBB;
        line-height: 1.2;
        letter-spacing: 1px;
        font-weight: 700;
    }

    .gh-playground-layout__title-sub {
        color: color.adjust($textColor, $lightness: 20%);
        letter-spacing: 8px;
        font-family: $fontTitle;
    }
</style>
